const DEFAULT_DAYS_FROM = 45;
const PAYMENT_TYPES = {
  CASH: 'Cash',
  ACH: 'ACH',
  CREDIT: 'Credit',
  DEBIT: 'Debit',
  CARD: 'Card',
  NA: 'N/A',
};

const PAYMENT_STATUS_MAP = [
  { value: 'pastdue', label: 'Past Due' },
  { value: 'paid', label: 'Paid' },
  { value: 'pending', label: 'Pending' },
  { value: 'deleted', label: 'Deleted' },
  { value: 'archived', label: 'Archived' },
];

/**
 * Get invoice payment type from db invoice record
 * @param {import("../../types/invoices").IInvoiceModel} invoice
 * @returns
 */
const getPaymentType = (invoice) => {
  if (invoice.CASH) {
    return PAYMENT_TYPES.CASH;
  }

  let paymentType = PAYMENT_TYPES.NA;
  const index = invoice?.creditOrDebit?.toUpperCase() ?? invoice?.cardType?.toUpperCase();
  if (index && index in PAYMENT_TYPES) {
    // @ts-ignore - verified in if statement
    paymentType = PAYMENT_TYPES[index];
  }

  return paymentType;
};

/**
 * Get invoice payment status from db invoice record
 * @param {import("../../types/invoices").IInvoiceModel} invoice
 * @returns
 */
const getPaymentStatus = (invoice) => {
  if (invoice.isArchived) {
    return 'archived';
  } else if (invoice.STATUS?.toLowerCase() === 'pending') {
    const [dueDateMonth, dueDateDay, dueDateYear] = new Date(invoice.dueDate).toLocaleDateString('en-US').split('/');
    const dueDate = new Date(dueDateYear, parseInt(dueDateMonth) - 1, dueDateDay);
    dueDate.setHours(23, 59, 59);
    const isPastDueDate = dueDate < new Date();
    if (isPastDueDate) {
      return 'pastdue';
    }
  }
  return invoice.STATUS;
};

/**
 * Get invoice first name from db invoice record
 * @param {any} invoice
 * @returns
 */
const getInvoiceFirstName = (invoice) => {
  const firstName =
    invoice.firstName ??
    invoice.customerId?.firstName ??
    invoice.oneTimeCustomerDetails?.firstName ??
    invoice.payerName ??
    '';
  return firstName;
};

/**
 * Get invoice last name from db invoice record
 * @param {any} invoice
 * @returns
 */
const getInvoiceLastName = (invoice) => {
  const lastName = invoice.lastName ?? invoice.customerId?.lastName ?? invoice.oneTimeCustomerDetails?.lastName ?? '';
  return lastName;
};

export {
  DEFAULT_DAYS_FROM,
  PAYMENT_STATUS_MAP,
  PAYMENT_TYPES,
  getInvoiceFirstName,
  getInvoiceLastName,
  getPaymentStatus,
  getPaymentType,
};
